/**
 * Build a reliable map embed URL for a project.
 * Priority:
 *  1. If project.map_embed_url is set AND looks like a valid embed iframe URL (contains /maps/embed/ or openstreetmap.org/export/embed),
 *     use it as-is.
 *  2. Otherwise, if gps_lat/gps_lng exist, build an OpenStreetMap embed URL (no X-Frame-Options restrictions).
 *  3. Otherwise, return an empty string (no map shown).
 */
export function buildMapEmbedUrl(project) {
  if (!project) return "";
  const url = (project.map_embed_url || "").trim();
  const isProperEmbed =
    url.includes("google.com/maps/embed") ||
    url.includes("openstreetmap.org/export/embed");
  if (isProperEmbed) return url;

  const lat = Number(project.gps_lat);
  const lng = Number(project.gps_lng);
  if (Number.isFinite(lat) && Number.isFinite(lng) && lat !== 0 && lng !== 0) {
    const delta = 0.01;
    const bbox = `${lng - delta},${lat - delta},${lng + delta},${lat + delta}`;
    return `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat},${lng}`;
  }
  return "";
}
